var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"width":1600,"title":_vm.theTitle},on:{"close":_vm.close},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('Insights',{attrs:{"projectId":_vm.projectId,"source":_vm.source}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }